var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_24248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7656 12.0586C24.7656 15.2412 23.5013 18.2934 21.2509 20.5439C19.0005 22.7943 15.9482 24.0586 12.7656 24.0586C9.58303 24.0586 6.53078 22.7943 4.28034 20.5439C2.02991 18.2934 0.765625 15.2412 0.765625 12.0586C0.765625 8.876 2.02991 5.82375 4.28034 3.57331C6.53078 1.32288 9.58303 0.0585938 12.7656 0.0585938C15.9482 0.0585938 19.0005 1.32288 21.2509 3.57331C23.5013 5.82375 24.7656 8.876 24.7656 12.0586ZM18.8106 7.51359C18.7035 7.40682 18.5759 7.32275 18.4355 7.26642C18.2951 7.21008 18.1448 7.18263 17.9936 7.18571C17.8424 7.18879 17.6933 7.22234 17.5554 7.28435C17.4174 7.34635 17.2933 7.43555 17.1906 7.54659L11.9811 14.1841L8.84163 11.0431C8.62836 10.8444 8.34629 10.7362 8.05484 10.7413C7.76339 10.7465 7.48531 10.8645 7.27919 11.0707C7.07307 11.2768 6.95501 11.5549 6.94986 11.8463C6.94472 12.1378 7.0529 12.4198 7.25163 12.6331L11.2206 16.6036C11.3275 16.7103 11.4549 16.7944 11.595 16.8509C11.7351 16.9073 11.8852 16.935 12.0362 16.9322C12.1873 16.9294 12.3362 16.8962 12.4742 16.8346C12.6121 16.773 12.7362 16.6842 12.8391 16.5736L18.8271 9.08859C19.0313 8.87634 19.144 8.59251 19.1412 8.29803C19.1384 8.00355 19.0203 7.72192 18.8121 7.51359H18.8106Z",
    fill: "#1F8DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_24248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.765625 0.0585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check-circle-fill.73caa62a765ac3aa1a753a1c0c741376.svg";
export { ForwardRef as ReactComponent };